import BasicArea from "../../../../assets/charts/basicArea.png";
import BasicBar from "../../../../assets/charts/basicBar.png";
import BasicLine from "../../../../assets/charts/basicLine.png";
import ColumnLine from "../../../../assets/charts/columnLine.png";
import DonutChart from "../../../../assets/charts/donutChart.png";
import GroupBar from "../../../../assets/charts/groupBar.png";
import Histogram from "../../../../assets/charts/histogram.jpg";
import MultiLine from "../../../../assets/charts/multiLine.png";
import PercentBar from "../../../../assets/charts/percentBar.png";
import PieChart from "../../../../assets/charts/pieChart.png";
import Radar from "../../../../assets/charts/radar.png";
import RadarMultiLine from "../../../../assets/charts/radarMultiLine.png";
import RangeBar from "../../../../assets/charts/rangeBar.png";
import StackedArea from "../../../../assets/charts/stackedArea.png";
import StackedBar from "../../../../assets/charts/stackedBar.png";
import StepLine from "../../../../assets/charts/stepLine.png";
import WordCloud from "../../../../assets/charts/wordCloud.png";
import ChartType from "../../ChartType.json";

export const getChartImage = (chartType) => {
	switch (chartType) {
		case ChartType.BasicArea:
			return BasicArea;
		case ChartType.BasicBar:
			return BasicBar;
		case ChartType.BasicLine:
			return BasicLine;
		case ChartType.ColumnLine:
			return ColumnLine;
		case ChartType.DonutChart:
			return DonutChart;
		case ChartType.GroupBar:
			return GroupBar;
		case ChartType.Histogram:
			return Histogram;
		case ChartType.MultiLine:
			return MultiLine;
		case ChartType.PercentBar:
			return PercentBar;
		case ChartType.PieChart:
			return PieChart;
		case ChartType.Radar:
			return Radar;
		case ChartType.RadarMultiLine:
			return RadarMultiLine;
		case ChartType.RangeBar:
			return RangeBar;
		case ChartType.StackedArea:
			return StackedArea;
		case ChartType.StackedBar:
			return StackedBar;
		case ChartType.StepLine:
			return StepLine;
		case ChartType.WordCloud:
			return WordCloud;
		default:
			return "";
	}
};
